module.exports = __webpack_public_path__ + "static/media/home-purple.823baf1c.svg";